// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin__details__title {
  color: var(--primary);
  font-weight: 600;
  margin: 0 0 1rem;
  font-size: var(--subheader);
}

.admin__details__box__wrapper {
  display: flex;
  margin-top: 5px;
}

.admin__details__box {
  display: flex;
  flex-direction: column;
  width: auto;
}

.admin__details__btn {
  display: flex;
  align-items: center;
  border-radius: .5rem;
  margin: 1rem;
}

.admin__details_search__btn {
  font-style: normal;
  width: 60px;
  background-color: var(--primary) !important;
  color: #F1F0EF !important;
  text-transform: none !important;
}

.admin__details_search__btn:hover {
  box-shadow: 0px 3px 10px 3px rgb(0 0 0 / 20%) !important;
}

.access__details.selection__box {
  margin: 20px 0 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 20rem;
}

.admin__details_search__btn {
  cursor: pointer;
}

.client-search-treeview-box {
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 390px;
}

.selected-clients-treeview-box {
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 390px;
}

.admin__details__box.search-clients {
  margin-right: 85px;
  margin-left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/Modules/AdminManagement/searchTab/SearchDetails/AccessDetails.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,2CAA2C;EAC3C,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".admin__details__title {\n  color: var(--primary);\n  font-weight: 600;\n  margin: 0 0 1rem;\n  font-size: var(--subheader);\n}\n\n.admin__details__box__wrapper {\n  display: flex;\n  margin-top: 5px;\n}\n\n.admin__details__box {\n  display: flex;\n  flex-direction: column;\n  width: auto;\n}\n\n.admin__details__btn {\n  display: flex;\n  align-items: center;\n  border-radius: .5rem;\n  margin: 1rem;\n}\n\n.admin__details_search__btn {\n  font-style: normal;\n  width: 60px;\n  background-color: var(--primary) !important;\n  color: #F1F0EF !important;\n  text-transform: none !important;\n}\n\n.admin__details_search__btn:hover {\n  box-shadow: 0px 3px 10px 3px rgb(0 0 0 / 20%) !important;\n}\n\n.access__details.selection__box {\n  margin: 20px 0 20px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  height: 20rem;\n}\n\n.admin__details_search__btn {\n  cursor: pointer;\n}\n\n.client-search-treeview-box {\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 390px;\n}\n\n.selected-clients-treeview-box {\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 390px;\n}\n\n.admin__details__box.search-clients {\n  margin-right: 85px;\n  margin-left: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
